<template>
  <form
    v-if="myAccount"
    @submit.prevent
    @submit="persist"
  >
    <t-alert v-if="errorMessage">
      {{ errorMessage }}
    </t-alert>

    <h2 class="font-bold mb-4">
      Informations générales
    </h2>

    <div class="grid grid-cols-2 gap-8 mb-12">
      <div class="col-span-1">
        <div class="input required">
          <label for="account-fullname">Nom complet</label>
          <input
            id="account-fullname"
            v-model="myAccount.fullName"
            type="text"
            required
            placeholder="Entrez votre prénom et nom"
          >
          <div
            v-if="errors.fullName"
            class="error"
          >
            {{ errors.fullName }}
          </div>
        </div>
      </div>
      <div class="col-span-1">
        <div class="input required">
          <label for="account-email">Adresse Email</label>
          <input
            id="account-email"
            v-model="myAccount.email"
            type="email"
            required
            placeholder="Entrez votre adresse email"
          >
          <div
            v-if="errors.email"
            class="error"
          >
            {{ errors.email }}
          </div>
          <div class="flex items-center mt-3">
            <input
              id="email-notifications"
              v-model="myAccount.emailNotifications"
              type="checkbox"
              value="1"
            >
            <label
              class="ml-2"
              for="email-notifications"
            >
              Recevoir les notifications quand une annonce a été créée ?
            </label>
          </div>
        </div>
      </div>
      <div class="col-span-1">
        <div class="input">
          <label for="account-phone-number">Numéro de téléphone</label>
          <input
            id="account-phone-number"
            v-model="myAccount.phoneNumber"
            type="text"
            placeholder="Entrez votre numéro de téléphone"
          >
          <div
            v-if="errors.phoneNumber"
            class="error"
          >
            {{ errors.phoneNumber }}
          </div>
        </div>
      </div>
      <div class="col-span-1">
        <div class="input">
          <label for="account-password">Nouveau mot de passe</label>
          <input
            id="account-password"
            v-model="myAccount.password"
            type="password"
            placeholder="Entrez votre mot de passe"
          >
          <div
            v-if="errors.password"
            class="error"
          >
            {{ errors.password }}
          </div>
        </div>
      </div>
      <div class="col-span-1">
        <div class="input">
          <label for="account-password-confirmation">Confirmation Nouveau mot de passe</label>
          <input
            id="account-password-confirmation"
            v-model="myAccount.passwordConfirmation"
            type="password"
            placeholder="Entrez la confirmation du mot de passe"
          >
          <div
            v-if="errors.passwordConfirmation"
            class="error"
          >
            {{ errors.passwordConfirmation }}
          </div>
        </div>
      </div>
    </div>

    <h2 class="font-bold mb-4">
      Informations société
    </h2>

    <div class="grid grid-cols-2 gap-8">
      <div class="col-span-1">
        <div class="input">
          <label for="account-company">Nom de la société</label>
          <input
            id="account-company"
            v-model="myAccount.companyName"
            type="text"
            placeholder="Entrez le nom de votre société"
          >
          <div
            v-if="errors.companyName"
            class="error"
          >
            {{ errors.companyName }}
          </div>
          <div class="hint">
            Cette information sera reprise lors de la facturation.
          </div>
        </div>
      </div>
      <div class="col-span-1">
        <div class="input">
          <label for="account-company-registration-number">Numéro de SIRET</label>
          <input
            id="account-company-registration-number"
            v-model="myAccount.companyRegistrationNumber"
            type="text"
            placeholder="Entrez le numéro de SIRET de votre société"
          >
          <div
            v-if="errors.companyRegistrationNumber"
            class="error"
          >
            {{ errors.companyRegistrationNumber }}
          </div>
          <div class="hint">
            Cette information sera reprise lors de la facturation.
          </div>
        </div>
      </div>
    </div>

    <div class="mt-12 text-right">
      <t-submit-button
        :button-state="buttonState"
        :labels="{ default: 'Enregistrer', inProgress: 'En cours...', success: 'Profil modifié !', fail: 'Échec' }"
      />
    </div>
  </form>
</template>

<script>
import * as MyAccountService from '@/services/my-account';
import { toCamel } from '@/shared/utils';

export default {
  name: 'EditMyaccount',
  data() {
    return {
      myAccount: undefined,
      errorMessage: false,
      errors: {},
      buttonState: 'default'
    };
  },
  mounted() {
    MyAccountService.show().then(({ account }) => this.myAccount = account);
  },
  methods: {
    persist() {
      this.resetForm(false);
      MyAccountService.update({ ...this.myAccount })
      .then(account => this.onSuccess(account))
      .catch(exception => this.onError(exception.response?.data?.errors));
    },
    onSuccess(account) {
      this.buttonState = 'success';
      this.myAccount = account;
    },
    onError(errors) {
      this.buttonState = 'fail';
      if (errors) {
        this.errorMessage = "Le formulaire n'est pas valide";
        for (const key in errors || {})
        this.errors[toCamel(key)] = errors[key][0];
      } else {
        this.errorMessage = "Veuillez contacter notre support technique";
      }
    },
    resetForm(brandNew) {
      this.buttonState = brandNew ? 'default' : 'inProgress';
      this.errorMessage = null;
      this.errors = {};
    }
  }
};
</script>
